import { Plus, Trash2 } from "lucide-react";
import { C, DOC_OPTS, IMPACTO_OPTS, RESPALDO_OPTS } from "./constants";
import { PrivacyNote } from "./PrivacyNote";

export const EMPTY_FUNCION = { nombre: "", impacto: "", respaldo: "", documentacion: "" };
const MAX = 12;

const Select = ({ value, onChange, opts, label, testid }) => (
  <label className="flex flex-col gap-1 text-[11px] font-semibold" style={{ color: "#5B6B64" }}>
    {label}
    <select value={value} onChange={(e) => onChange(e.target.value)} className="rounded-lg border bg-white px-2 py-2 text-sm font-normal" style={{ borderColor: "#CBD5CF", color: C.text }} data-testid={testid}>
      <option value="">Elige…</option>
      {opts.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
    </select>
  </label>
);

const Row = ({ f, i, onChange, onRemove, canRemove }) => (
  <div className="rounded-xl bg-white border p-3 grid gap-2 md:grid-cols-[1fr_110px_230px_110px_36px] md:items-start" style={{ borderColor: "#E3E7E1" }} data-testid={`tablero-funcion-row-${i}`}>
    <label className="flex flex-col gap-1 text-[11px] font-semibold" style={{ color: "#5B6B64" }}>
      Función crítica
      <input value={f.nombre} maxLength={60} onChange={(e) => onChange({ ...f, nombre: e.target.value })} placeholder="Ej.: facturación a clientes" className="rounded-lg border px-3 py-2 text-sm font-normal" style={{ borderColor: "#CBD5CF", color: C.text }} data-testid={`tablero-funcion-nombre-${i}`} />
      <PrivacyNote testid={`tablero-privacy-note-funcion-${i}`} />
    </label>
    <Select label="Impacto si falla" value={f.impacto} opts={IMPACTO_OPTS} onChange={(v) => onChange({ ...f, impacto: v })} testid={`tablero-funcion-impacto-${i}`} />
    <Select label="Respaldo" value={f.respaldo} opts={RESPALDO_OPTS} onChange={(v) => onChange({ ...f, respaldo: v })} testid={`tablero-funcion-respaldo-${i}`} />
    <Select label="Documentada" value={f.documentacion} opts={DOC_OPTS} onChange={(v) => onChange({ ...f, documentacion: v })} testid={`tablero-funcion-doc-${i}`} />
    <button type="button" onClick={onRemove} disabled={!canRemove} className="md:mt-5 h-9 w-9 inline-flex items-center justify-center rounded-lg border disabled:opacity-30" style={{ borderColor: "#CBD5CF" }} aria-label="Quitar función" data-testid={`tablero-funcion-remove-${i}`}>
      <Trash2 className="w-4 h-4" style={{ color: C.text }} />
    </button>
  </div>
);

export const FuncionesEditor = ({ funciones, setFunciones }) => {
  const update = (i, f) => setFunciones(funciones.map((x, j) => (j === i ? f : x)));
  return (
    <div className="space-y-2" data-testid="tablero-funciones-editor">
      {funciones.map((f, i) => (
        <Row key={i} f={f} i={i} onChange={(nf) => update(i, nf)} onRemove={() => setFunciones(funciones.filter((_, j) => j !== i))} canRemove={funciones.length > 5} />
      ))}
      {funciones.length < MAX && (
        <button type="button" onClick={() => setFunciones([...funciones, { ...EMPTY_FUNCION }])} className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: C.green }} data-testid="tablero-funcion-add">
          <Plus className="w-4 h-4" /> Añadir función ({funciones.length} de {MAX})
        </button>
      )}
    </div>
  );
};

export const funcionesValid = (fs) => fs.length >= 5 && fs.length <= MAX && fs.every((f) => f.nombre.trim() && f.impacto && f.respaldo && f.documentacion);
